module.exports = __webpack_public_path__ + "public/images/tab-active.b57bd6e5853802e573dcd65fa95e87ec.svg";